
<div *ngIf="layout">
  <div> topology : {{layout['topology']}}</div>
    <div class="card ps-2">
      body
    <div *ngFor="let body of layout['body']">
     <div class="ms-4">{{body['value']}}</div>
    </div>
    </div>
    prompts
    <div *ngFor="let prompt of layout['prompts']" class="card ps-2 m-2">
      body
       <div *ngFor="let body of prompt['body']" class="ms-4">
        <i class="fa fa-dot"></i>{{body['value']}}
      </div>

        answer
        <div class="ms-2"> valuetype : {{prompt['answer']['valuetype']}}</div>
        <div class="ms-2"> source : {{prompt['answer']['source']}}</div>
        <div class="ms-2"> value : {{prompt['answer']['value']}}</div>

        <div *ngFor="let presentation of prompt['answer']['presentations']" class="mt-2">
          <div class="ms-2"> presentationType : {{presentation['presentationType']}}</div>
          <div *ngIf="presentation['presentationType']=='RADIOGROUP'" class="ms-2">
             answerOptions
             <div *ngFor="let answerOption of presentation['answerOptions']" class="ms-2">
              <div>valuetype: {{answerOption['valuetype']}} </div>
              <div>source: {{answerOption['source']}} </div>
              <div *ngIf="answerOption['source']=='system'">boldManager: {{answerOption['boldManager']}}</div>
              <div *ngIf="answerOption['source']=='system'">id: {{answerOption['id']}}</div>
              <div *ngIf="answerOption['source']!='system'">value: {{answerOption['value']}}</div>
              <div *ngIf="answerOption['params']">
              params
              <div *ngFor="let param of answerOption['params']" class="ms-2">
                <div class="ms-4">
                  valuetype: {{param['valuetype']}},
                  source: {{param['source']}},
                  value: {{param['value']}}
                </div>
              </div>
              </div>
             </div>
          </div>
        </div>



  </div><!--Prompt-->
</div><!--layout-->
